var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"inputglya",class:_vm.myclass,attrs:{"items":_vm.opciones,"item-text":"key","item-value":"value","outlined":_vm.outlined,"label":_vm.label_show},on:{"change":_vm.updateValue},model:{value:(_vm.valuey),callback:function ($$v) {_vm.valuey=$$v},expression:"valuey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }